import Button from 'components/CncUI/Button';
import usePlaidLink from '../hooks/usePlaidLink';

const PlaidOAuthButton = props => {
  const { token, onExit, onSuccess } = props;
  const [openPlaid, plaidReady] = usePlaidLink(onSuccess, onExit, token, true);

  return (
    <Button
      id="PlaidOAuthButton"
      style={{ display: 'none' }}
      disabled={!plaidReady}
      onClick={() => openPlaid()}
    >
      Plaid OAuth Widget
    </Button>
  );
};

export default PlaidOAuthButton;
